import { render, staticRenderFns } from "./region.vue?vue&type=template&id=c4045a42&scoped=true&"
import script from "./region.vue?vue&type=script&lang=js&"
export * from "./region.vue?vue&type=script&lang=js&"
import style0 from "./region.vue?vue&type=style&index=0&id=c4045a42&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4045a42",
  null
  
)

export default component.exports